import {NgModule} from '@angular/core';
import {MatExpansionModule, MatMenuModule} from '@angular/material';
import {PROFILE_SHARED_COMPONENTS} from './components';
import {
    AriadnextService,
    CustomerProfileService,
    IntegrationModuleService,
    KycService,
    OnfidoService
} from './api/service';
import {TranslateModule} from '@ngx-translate/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from '../../../shared';
import {CustomerEmailService} from './api/service/customer.email.service';
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {RANGE_RADIO_GROUP_COMPONENTS} from './components/range-radio-group';
import {FUNDS_INFORMATION_COMPONENTS} from './components/funds.information';
import {EXPECTED_TURNOVER_COMPONENTS} from './components/expected.turnover';
import {BUSINESS_TYPE_CATEGORIES} from "./components/business-categories";
import {ChosenCategoryService} from "../../../../../common/components/business-category/chosen-category.service";
import {ClipboardModule} from 'ngx-clipboard';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        TranslateModule,
        MatMenuModule,
        SharedModule,
        MatProgressSpinnerModule,
        MatExpansionModule,
        ClipboardModule
    ],
    declarations: [
        ...PROFILE_SHARED_COMPONENTS,
        ...RANGE_RADIO_GROUP_COMPONENTS,
        ...FUNDS_INFORMATION_COMPONENTS,
        ...EXPECTED_TURNOVER_COMPONENTS,
        ...BUSINESS_TYPE_CATEGORIES
    ],
    providers: [
        CustomerProfileService,
        KycService,
        OnfidoService,
        IntegrationModuleService,
        AriadnextService,
        CustomerEmailService,
        ChosenCategoryService,
    ],
    exports: [
        ...PROFILE_SHARED_COMPONENTS,
        ...RANGE_RADIO_GROUP_COMPONENTS,
        ...FUNDS_INFORMATION_COMPONENTS,
        ...EXPECTED_TURNOVER_COMPONENTS,
        ...BUSINESS_TYPE_CATEGORIES
    ]
})
export class CustomerProfilesSharedModule {

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/customer-profiles.shared.module.ts